import { RootState } from "@/app/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { Comment, CommentsState } from "./types/comments.types";

const initialState: CommentsState = {
  comments: [],
};

export const commentsSlice = createSlice({
  name: "comments",
  initialState,
  reducers: {
    // Save all comments from the API response
    setComments: (state, action: PayloadAction<Comment[]>) => {
      state.comments = action.payload;
    },

    // Add a single new comment to the list
    addComment: (state, action: PayloadAction<Comment>) => {
      state.comments.push(action.payload);
    },
  },
});

// Export actions
export const { setComments, addComment } = commentsSlice.actions;

// Selectors
export const selectCommentsState = (state: RootState) => state.comments;
export const selectComments = (state: RootState) => state.comments.comments;

// Helper function to get comments from RTK Query cache
const getCommentsFromCache = (state: RootState, surveyId: string) => {
  const queryResult =
    state.commentsApi.queries[`getSurveyComments(${JSON.stringify(surveyId)})`];
  return (queryResult?.data as Comment[]) || [];
};

// Updated selectors that look at RTK Query cache
export const selectPropertyComments = (
  state: RootState,
  propertyId: string,
  surveyId: string,
) => {
  const comments = getCommentsFromCache(state, surveyId);
  return comments.filter((comment) => comment.propertyId === propertyId);
};

export const selectHasPropertyComments = (
  state: RootState,
  propertyId: string,
  surveyId: string,
) => {
  const comments = getCommentsFromCache(state, surveyId);
  return comments.some((comment) => comment.propertyId === propertyId);
};

export default commentsSlice.reducer;
